import { gql } from '@apollo/client';

// Spec 021 (and spec 027's environment settings). Fields are written out in each document: codegen skips documents built with `${}`.

/** Platform owner: every brand's setting for every mobile app feature. */
export const APP_FEATURE_MATRIX = gql`
  query AppFeatureMatrix {
    appFeatureMatrix {
      features {
        key
        group
        defaultEnabled
        label
        description
      }
      brands {
        brandSite
        displayName
        features {
          brandSite
          feature
          enabled
          updatedAt
          updatedBy {
            id
            name
            email
          }
        }
      }
    }
  }
`;

/** Platform owner: one cell. Refused with APP_FEATURE_STALE when `expectedEnabled` is not the stored value. */
export const SET_BRAND_APP_FEATURE = gql`
  mutation SetBrandAppFeature($input: SetBrandAppFeatureInput!) {
    setBrandAppFeature(input: $input) {
      brandSite
      feature
      enabled
      updatedAt
      updatedBy {
        id
        name
        email
      }
    }
  }
`;

/** Platform owner: changes, newest first; `before` is the id of the last one shown. */
export const APP_FEATURE_HISTORY = gql`
  query AppFeatureHistory($limit: Int, $before: ID) {
    appFeatureHistory(limit: $limit, before: $before) {
      id
      brandSite
      feature
      oldValue
      newValue
      changedAt
      changedBy {
        id
        name
        email
      }
    }
  }
`;
